import React from 'react'
import { Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Row } from 'reactstrap'

const FiltroFestivos = (props) => {

  return (
    <>
     <Card className="shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Calendario de festivos</h3>
                  </Col>
                 
                </Row>
              </CardHeader>
              <CardBody>
              <Form>
                
                  
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="centro"
                          >
                            Centro
                          </label>
                   
                        <Input type="select" name="centro" id="centro" value={props.centroIdSelected} onChange={(e) => props.setCentroIdSelected(e.target.value || null)}>
                            <option key={"nullcentro"} value={"null"}>Seleccionar centro</option>
                            {props.centros?.map(centro =>{
                                return <option key={centro.id} value={centro.id}>{centro.nombre}</option>
                            })}
                           
                        </Input>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                           Año
                          </label>
                          <Input type="number" name="anno" id="anno" value={props.annoSelected} onChange={(e) => props.setAnnoSelected(e.target.value)}>

                          

                        </Input>
                        </FormGroup>
                      </Col>
                    </Row>
    
                  </div>
                 
                 
                
                </Form>
              </CardBody>
            </Card>
    </>
  )
}

export default FiltroFestivos